<template>
    <paper class="work-monthly">
        <div class="monthly-title" v-if="chartShow">综合绩效考核评分</div>
        <div class="work-monthly-head" v-if="chartShow">
            <div id="myChart" :style="{width: '100%', height: '400px'}"></div>
        </div>
        <monthlyTable :height="chartShow?'calc(100vh - 555px)':'80vh'" @chartData="chartData"></monthlyTable>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import monthlyTable from './workMonthlyTable.vue';
export default {
    name: 'workMonthly',
    components: { paper, monthlyTable },
    data() {
        return {
            myChart: '',
            chartShow: false,
            color: ['#40E0D0', '#FFD700', '#1C86EE', '#FF6A6A', '#FF00FF', '#FFE7BA', '#CDCDB4', '#00008B', '#58bc58'],
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '6%',
                    right: '6%',
                    bottom: '6%',
                    containLabel: true
                },
                legend: {
                    data: [],
                    right: '6%',
                    top: '0',
                    itemWidth: 5, // 图例图标的宽
                    itemHeight: 15, // 图例图标的高
                    textStyle: {
                        color: '#333333',
                        fontSize: 14
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: 'category',
                        data: [],
                        splitLine: { show: false }, // 去除网格分割线
                        axisTick: {// 刻度
                            show: false// 不显示刻度线
                        },
                        axisLine: {// 坐标线
                            lineStyle: {
                                type: 'solid',
                                color: '#e7e7e7', // 轴线的颜色
                                width: '2'// 坐标线的宽度
                            }
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#33333' // 坐标值的具体的颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        max: '100',
                        min: '0',
                        splitNumber: 10,
                        axisLine: {// 线
                            show: false
                        },
                        axisTick: {// 刻度
                            show: false
                        },
                        axisLabel: {
                            formatter: '{value}.00%',
                            textStyle: {
                                color: '#33333' // 坐标值的具体的颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: ['#e7e7e7'] // 分割线的颜色
                            }
                        }
                    },
                    {
                        type: 'value',
                        max: '100',
                        min: '0',
                        splitNumber: 10,
                        axisLine: {// 线
                            show: false
                        },
                        axisTick: {// 刻度
                            show: false
                        },
                        axisLabel: {
                            formatter: '{value}.00',
                            textStyle: {
                                color: '#33333' // 坐标值的具体的颜色
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: ['#e7e7e7'] // 分割线的颜色
                            }
                        }
                    }

                ],
                series: []
            }
        };
    },
    methods: {
        drawLine() {
            this.myChart = this.$echarts.init(document.getElementById('myChart'));// 获取容器元素
            // // 防止越界，重绘canvas
            window.onresize = this.myChart.resize;
            this.myChart.setOption(this.option);// 设置option
        },
        chartData(res) {
            this.chartShow = true;
            this.$nextTick(() => {
                this.drawLine();
                Object.assign(this.$data.option, this.$options.data().option);
                window.onresize = this.myChart.resize;
                if (res.data[0]) {
                    const title = res.data[0].quotaTypeDtoList.map(item => { return item.quotaName; });
                    this.option.legend.data = title;
                    res.data[0].quotaTypeDtoList.forEach(item => {
                        const setUpObj = {
                            name: item.quotaName,
                            type: 'bar',
                            barWidth: 15,
                            data: [],
                            itemStyle: {
                                normal: {
                                    color: '' // 设置柱子颜色
                                }
                            }
                        };
                        this.option.series.push(setUpObj);
                    });
                    this.option.legend.data.push('综合评分');
                    const scoreObj = {
                        name: '综合评分',
                        type: 'line',
                        data: [],
                        itemStyle: {
                            normal: {
                                color: '#FF3030',
                                label: { show: true }
                            }
                        }
                    };
                    res.data.forEach(item => {
                        scoreObj.data.push(item.overallRating);
                        this.option.xAxis[0].data.push(item.assessmentMonth);
                        item.quotaTypeDtoList.forEach((item2, index2) => {
                            this.option.series[index2].itemStyle.normal.color = this.color[index2];
                            this.option.series[index2].data.push(item2.performanceResult);
                        });
                    });
                    this.option.series.push(scoreObj);
                }
                this.myChart.setOption(this.option, true);
            });
        }
    }
};
</script>
<style lang="less">
.work-monthly {
    .work-monthly-head {
        border-bottom: 2px solid #e7e7e7;
        margin-bottom: 10px;
        height: 400px;
    }
    .monthly-title{
        font-size: 16px;
        color: #333;
        font-weight:700;
        margin-bottom:5px;
    }
}
</style>